import * as React from "react";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import * as Paths from "@tunnel-enums/index";
import VirtualisationPagination from "@tunnel-components/@sharded/@widgets/incidents-virtualized/component";
import OngletIncident from "@tunnel-components/@sharded/widgets/onglet-navigation/component";
import MessageEmptyIncidents from "@tunnel-components/@sharded/message/component";
import * as Lodash from "lodash";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";
import * as i18next from "i18next"; // traduction

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    loading,
    incidentData,
    errorserver,
    /*totalRowElements,*/ onSound,
    audioBoolean,
    totalElements,
    itemsPerPage,
    itemPerRow,
    onChangeItemPerRow,
    onUpdateCurrentPageNumber,
    currentPageNumbers,
    ongletActive,
    onClickOnglet,
    incidentOngletParameter,
    /** Intégration des actions */
    identifiantActifSea,
    selectedValueSearch,
    actionFalseAlarmPatternsError,
    onSubmitSeaPatterns,
    onChangePatterns,
    onClosePattern,
    onSearchValue,
    patternfalseAlarm,
    selectedOptionsIncident,
    onCloseSeaPatterns,
    onSubmitPatterns,
    actionFalseAlarmPatterns,
    actionSeaPatterns,
    onQualified,
    onDeleteFakeIncident,
    actionLoader,
    onUpdateScrollTop,
    rediRectToo,
  } = props;
  /** Configuration dela viriable globale , L'objet window représente une fenêtre contenant un document DOM   */
  const API_URL = "env";
  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();

  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const authorization: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.HOMEQUALIFYINCIDENT,
  ]);

  const SYSTEMVIEWTUBES: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.SYSTEMVIEWTUBES,
  ]);

  const HOMENAVIGATIONONGLET: boolean = Utils.simpleAuthorizationIsAllowed(
    User,
    [Enums.AuthorizationRightsEnums.HOMENAVIGATIONONGLET]
  );

  /**
   * @description : retourne un tableau de type JSX
   * @const
   * @name incidentDataAll
   * @type { JSX.Element  }
   */
  const incidentDataAll: JSX.Element[] =
    !!incidentData && incidentData.filter((elem: any) => elem !== null);

  /**
   * @description : retourne un tableau de l'ensemble des incidents par groupe
   * @const
   * @name DataMap
   * @type { JSX.Element  }
   */
  const DataMap: any[] = [incidentDataAll];

  /**
   * @description : retourne un tableau
   * @const
   * @name onglet
   * @type { string[]  }
   */
  let onglet: any[] = [
    {
      title: i18next.t("vue globale"),
      action: "",
    },
  ];

  if (HOMENAVIGATIONONGLET) {
    onglet = [
      ...onglet,
      {
        title: i18next.t("a qualifier"),
        action: "",
      },
      {
        title: i18next.t("averes"),
        action: "",
      },
      {
        title: i18next.t("fausses alarmes"),
        action: "",
      },
    ];
  }

  if (SYSTEMVIEWTUBES) {
    onglet = [
      ...onglet,
      {
        title: i18next.t(window[API_URL].TUBE_O1),
        action: "",
      },
      {
        title: i18next.t(window[API_URL].TUBE_O2),
        action: "",
      },
      {
        title: i18next.t(window[API_URL].TUBE_O3),
        action: "",
      },
    ];
  }

  /**
   * @description : retourne un string ( environnement)
   * @function
   * @name breadCrumFunction
   * @return { string  }
   */
  const breadCrumFunction = (): string => {
    /**
     * @description :
     * @const
     * @name breadCrum
     * @type { string }
     */
    let breadCrum: string = "";

    if (ongletActive[0]) {
      breadCrum = i18next.t("vue globale");
    }
    if (ongletActive[1]) {
      breadCrum = i18next.t("a qualifier");
    }
    if (ongletActive[2]) {
      breadCrum = i18next.t("averes");
    }
    if (ongletActive[3]) {
      breadCrum = i18next.t("fausses alarmes");
    }
    if (ongletActive[4]) {
      breadCrum = i18next.t(window[API_URL].TUBE_O1);
    }
    if (ongletActive[5]) {
      breadCrum = i18next.t(window[API_URL].TUBE_O2);
    }
    if (ongletActive[6]) {
      breadCrum = i18next.t(window[API_URL].TUBE_O3);
    }

    return breadCrum;
  };

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @infos "https://reactjs.org"
   */

  return (
    <LayoutGrid
      loading={loading}
      error={errorserver}
      onChangeItemPerRow={onChangeItemPerRow}
      incidentPerRow={true}
    >
      {
        <section className="tunnel-site animated fadeIn">
          {Lodash.isEqual(incidentOngletParameter, "") &&
            Lodash.isEqual(Number(totalElements), 0) &&
            !Lodash.isUndefined(totalElements) && (
              <MessageEmptyIncidents
                message={i18next.t(
                  "aucun incident ne requiert votre attention"
                )}
                emptyIncident={true}
              />
            )}
          {!!incidentData && (
            <BreadCrumb
              title={i18next.t("incidents")}
              breadText1={breadCrumFunction()}
              links={Paths.PathsNamesEnums.TUNNELWATCH}
              iconIncident={true}
            />
          )}
          {!!incidentData && (
            <OngletIncident
              onglet={onglet}
              onClickOnglet={onClickOnglet}
              ongletActive={ongletActive}
              onSound={onSound}
              incidenSound={false}
              audioBoolean={audioBoolean}
            />
          )}
          <div
            className="inhibitionespace"
            style={{ position: "relative", width: "100%", margin: "5px 0" }}
          />
          <div className="contentAllSite">
            <section id="columns" className="with-3-columns">
              {DataMap.map((elem: any, eudes: number) => {
                return (
                  itemsPerPage && (
                    <VirtualisationPagination
                      key={eudes}
                      incidentData={elem}
                      identifiantActifSea={identifiantActifSea}
                      selectedValueSearch={selectedValueSearch}
                      actionFalseAlarmPatternsError={
                        actionFalseAlarmPatternsError
                      }
                      onSubmitSeaPatterns={onSubmitSeaPatterns}
                      onChangePatterns={onChangePatterns}
                      onClosePattern={onClosePattern}
                      onSearchValue={onSearchValue}
                      authorization={authorization}
                      patternfalseAlarm={patternfalseAlarm}
                      selectedOptionsIncident={selectedOptionsIncident}
                      onCloseSeaPatterns={onCloseSeaPatterns}
                      onSubmitPatterns={onSubmitPatterns}
                      actionFalseAlarmPatterns={actionFalseAlarmPatterns}
                      actionSeaPatterns={actionSeaPatterns}
                      onQualified={onQualified}
                      onDeleteFakeIncident={onDeleteFakeIncident}
                      actionLoader={actionLoader}
                      onUpdateScrollTop={onUpdateScrollTop}
                      onUpdateCurrentPageNumber={onUpdateCurrentPageNumber}
                      currentPageNumbers={currentPageNumbers}
                      itemPerRow={itemPerRow}
                      rediRectToo={rediRectToo}
                      // totalRowElements={totalRowElements}
                      totalRowElements={elem.length}
                      totalElements={totalElements}
                      itemsPerPage={itemsPerPage}
                    />
                  )
                );
              })}
            </section>
          </div>
        </section>
      }
    </LayoutGrid>
  );
};
/** Valeurs par défaut des props */
Component.defaultProps = {};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onUpdateScrollTop?: any;
  loading?: any;
  incidentData?: any;
  errorserver?: any;
  totalElements?: any;
  itemsPerPage?: any;
  onUpdateCurrentPageNumber?: any;
  currentPageNumbers?: any;
  itemPerRow?: any;
  onChangeItemPerRow?: any;
  ongletActive?: any;
  onClickOnglet?: any;
  totalRowElements?: any;
  //
  identifiantActifSea?: any;
  selectedValueSearch?: any;
  actionFalseAlarmPatternsError?: any;
  onSubmitSeaPatterns?: any;
  onChangePatterns?: any;
  onSearchValue?: any;
  patternfalseAlarm?: any;
  selectedOptionsIncident?: any;
  onCloseSeaPatterns?: any;
  onSubmitPatterns?: any;
  actionFalseAlarmPatterns?: any;
  actionSeaPatterns?: any;
  onQualified?: any;
  onDeleteFakeIncident?: any;
  actionLoader?: any;
  onClosePattern?: any;
  incidentOngletParameter?: string;
  onPlayBip?: any;
  onSound?: any;
  audioBoolean?: boolean;
  rediRectToo?: any;
}

/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/incidents/home/component.tsx